/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取我的印花兑换记录列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.PrintingExchangeDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/exchangePrintingList`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
